module.exports = __webpack_public_path__ + "img/visa.92930e5a.svg";